import { SettingOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

import { DUBLICATE_CLIENTS_SETTINGS_PATH } from '@app/routes/pages/duplicateClientsPages/constants';

export const DublicateClientsHeader = () => (
  <Link to={DUBLICATE_CLIENTS_SETTINGS_PATH}>
    <Button icon={<SettingOutlined />}>Настройки</Button>
  </Link>
);
